import { Link, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { getWebsiteUrl } from 'urlBuilder';

import { messages } from './TermsAndPolicy.messages';
import { TermsAndPolicyProps } from './TermsAndPolicy.types';

export const TermsAndPolicy = memo<TermsAndPolicyProps>((props) => {
    const { actionName } = props;

    return (
        <Text textAlign='center' font='body' fontSize='small'>
            {messages.byClicking({
                br: <br />,
                actionName,
                terms: (
                    <Link
                        external
                        font='body'
                        fontSize='small'
                        fontWeight='regular'
                        href={`${getWebsiteUrl(false)}terms`}
                    >
                        {messages.terms}
                    </Link>
                ),
                policy: (
                    <Link
                        external
                        font='body'
                        fontSize='small'
                        fontWeight='regular'
                        href={`${getWebsiteUrl(false)}policy`}
                    >
                        {messages.privacy}
                    </Link>
                ),
            })}
        </Text>
    );
});

TermsAndPolicy.displayName = 'TermsAndPolicy';
